import MonthGrid from '../MonthGrid';
import { generateDateRangeSet } from '../../functions/dateRange';
import { getStartDay } from '../../functions/date';

type MonthGridSectionProps = {
  year: number;
  periods: { start: string; end: string }[];
  setPeriods: React.Dispatch<React.SetStateAction<{ start: string; end: string }[]>>;
  holidayDates: Map<string, string>;
  periodDays: Set<string>;
  workWeek: 'five' | 'six';
};

export function MonthGridSection({ year, periods, setPeriods, holidayDates, periodDays, workWeek }: MonthGridSectionProps) {
  return (
    <div className="mt-3 sm:mt-4 px-1 sm:px-0">
      <MonthGrid
        year={year}
        periods={periods}
        setPeriods={setPeriods}
        holidayDates={holidayDates}
        periodDays={periodDays}
        getDateRange={generateDateRangeSet}
        getStartDay={getStartDay}
        enableMonthNavigation
        workWeek={workWeek}
      />
    </div>
  );
}
